import { KeyLabel, MOD } from './KeyLabel';

export const KeyLabelDvorak_fr: KeyLabel[] = [
  {
    code: 4,
    label: 'O',
  },
  {
    code: 5,
    label: 'Y',
  },
  {
    code: 6,
    label: ',',
    meta: [
      {
        label: '@',
        modifiers: MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 7,
    label: 'U',
  },
  {
    code: 8,
    label: 'é',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 9,
    label: 'E',
  },
  {
    code: 10,
    label: 'B',
  },
  {
    code: 11,
    label: 'F',
  },
  {
    code: 12,
    label: 'C',
  },
  {
    code: 13,
    label: 'S',
  },
  {
    code: 14,
    label: 'T',
  },
  {
    code: 15,
    label: 'N',
  },
  {
    code: 16,
    label: 'R',
  },
  {
    code: 17,
    label: 'X',
  },
  {
    code: 18,
    label: 'M',
  },
  {
    code: 19,
    label: 'K',
  },
  {
    code: 20,
    label: ':',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 21,
    label: 'G',
  },
  {
    code: 22,
    label: 'A',
  },
  {
    code: 23,
    label: '.',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 24,
    label: 'V',
  },
  {
    code: 25,
    label: 'I',
  },
  {
    code: 26,
    label: "'",
    meta: [
      {
        label: '<',
        modifiers: MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 27,
    label: 'Q',
  },
  {
    code: 28,
    label: 'H',
  },
  {
    code: 29,
    label: ';',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 30,
    label: '»',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 31,
    label: '/',
    meta: [
      {
        label: '2',
        modifiers: MOD.SFT,
      },
      {
        label: '2',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 32,
    label: '-',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 33,
    label: 'è',
    meta: [
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: '(backslash)',
    meta: [
      {
        label: '5',
        modifiers: MOD.SFT,
      },
      {
        label: '5',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 35,
    label: '^ (dead)',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 36,
    label: '(',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 37,
    label: '` (dead)',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 38,
    label: ')',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: '_',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 45,
    label: '[',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 46,
    label: ']',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 47,
    label: 'Z',
  },
  {
    code: 48,
    label: '¨ (dead)',
    meta: [
      {
        label: '=',
        modifiers: MOD.SFT,
      },
      {
        label: '=',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 50,
    label: '~ (dead)',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 51,
    label: 'D',
  },
  {
    code: 52,
    label: 'W',
  },
  {
    code: 53,
    label: '«',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: 'L',
  },
  {
    code: 55,
    label: 'P',
  },
  {
    code: 56,
    label: 'J',
  },
  {
    code: 100,
    label: 'à',
    meta: [
      {
        label: 'ç',
        modifiers: MOD.SFT,
      },
      {
        label: 'ç',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 518,
    label: '@',
  },
  {
    code: 520,
    label: '>',
  },
  {
    code: 532,
    label: '?',
  },
  {
    code: 535,
    label: '!',
  },
  {
    code: 538,
    label: '<',
  },
  {
    code: 541,
    label: '|',
  },
  {
    code: 542,
    label: '1',
  },
  {
    code: 543,
    label: '2',
  },
  {
    code: 544,
    label: '3',
  },
  {
    code: 545,
    label: '4',
  },
  {
    code: 546,
    label: '5',
  },
  {
    code: 547,
    label: '6',
  },
  {
    code: 548,
    label: '7',
  },
  {
    code: 549,
    label: '8',
  },
  {
    code: 550,
    label: '9',
  },
  {
    code: 551,
    label: '0',
  },
  {
    code: 557,
    label: '+',
  },
  {
    code: 558,
    label: '%',
  },
  {
    code: 560,
    label: '=',
  },
  {
    code: 562,
    label: '#',
  },
  {
    code: 565,
    label: '*',
  },
  {
    code: 612,
    label: 'ç',
  },
  {
    code: 4614,
    label: '@',
  },
  {
    code: 4616,
    label: '>',
  },
  {
    code: 4628,
    label: '?',
  },
  {
    code: 4631,
    label: '!',
  },
  {
    code: 4634,
    label: '<',
  },
  {
    code: 4637,
    label: '|',
  },
  {
    code: 4638,
    label: '1',
  },
  {
    code: 4639,
    label: '2',
  },
  {
    code: 4640,
    label: '3',
  },
  {
    code: 4641,
    label: '4',
  },
  {
    code: 4642,
    label: '5',
  },
  {
    code: 4643,
    label: '6',
  },
  {
    code: 4644,
    label: '7',
  },
  {
    code: 4645,
    label: '8',
  },
  {
    code: 4646,
    label: '9',
  },
  {
    code: 4647,
    label: '0',
  },
  {
    code: 4653,
    label: '+',
  },
  {
    code: 4654,
    label: '%',
  },
  {
    code: 4656,
    label: '=',
  },
  {
    code: 4658,
    label: '#',
  },
  {
    code: 4661,
    label: '*',
  },
  {
    code: 4708,
    label: 'ç',
  },
];
